import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { api, confirm } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box } from '@src/components';

// typing
interface LocalProps extends Props {
    urlMaintenances: string;
    onBatteryCycle: Function;
}

interface LocalState extends State {
    maintenances?: any;
}

// style
const lvars = {
    counter: 60
}
const style = css`
    > article {
        ${mixin.row2}

        > .table {
        }
        > .stats {
            text-align: center;
            
            > article {
                padding: 20px 0;
                .iconBadge {
                    ${mixin.iconBadge}

                    .fa-warning {
                        color: ${vars.colors.red};
                    }
                    .fa-medkit {
                        color: ${vars.colors.green};
                    }
                    .fa-wifi {
                        color: ${vars.colors.blue};
                    }
                }
                > h4 {
                    font-size: 24px;
                }
            }
        }
    }
`;

// component
export class Actions extends Proto<LocalProps, LocalState> {

    async componentDidMount() {
        const { urlMaintenances } = this.props;
        try {
            const res = await api({
                url: urlMaintenances,
                method: 'get'
            });
            if (res.status === 200) {
                this.setState({
                    maintenances: res.data.data,
                });
            } else {
            }
        } catch(e) {
        }
            
    }

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { onBattery, onBatteryCycle } = this.props;
        const { data, maintenances } = this.state;

        const fn = (row) => (
            <a className="download" /*onClick={() => { if (onBattery) onBattery({id: row.original.battery.id}); }}*/>
                {row.original.battery.name}
            </a>
        )

        const columnsActions = [
            { Header: _('actions_col_battery', 'Dash'), accessor: 'battery.name', Cell: fn  },
            { Header: _('actions_col_customer', 'Dash'), accessor: 'customer.name'},
            { Header: _('actions_col_truck_sn', 'Dash'), accessor: 'truck_sn' },
            { Header: _('actions_col_message', 'Dash'), accessor: "message" }
        ];
        const columnsMaintenances = [
            { Header: _('actions_col_battery_serialno', 'Dash'), accessor: 'battery.serialno', Cell: (row) => (
                <a className="download" onClick={(e) => { e.stopPropagation(); if (onBatteryCycle) onBatteryCycle({id: row.original.battery.id}); }}>
                    {row.original.battery.serialno}
                </a>
            ) },
            { Header: _('actions_col_battery_description', 'Dash'), accessor: 'battery.description', Cell: fn  },
            { Header: _('actions_col_expiration', 'Dash'), id: "expiration", accessor: v => v.expiration ? formatters.date(v.expiration) : null },
            { Header: _('actions_col_note', 'Dash'), accessor: 'note' },
            { Header: _('actions_col_completed', 'Dash'), id: 'completed', accessor: v => formatters.yesNo(v.completed) },
        ];
        const columnsErrors = [
            { Header: _('actions_col_battery', 'Dash'), accessor: 'battery.name', Cell: fn  },
            { Header: _('actions_col_device', 'Dash'), accessor: 'bms.name' },
            { Header: _('actions_col_brand', 'Dash'), accessor: 'battery.brand' },
            { Header: _('actions_col_customer', 'Dash'), accessor: 'customer.name'},
            { Header: _('actions_col_downloaded_at', 'Dash'), id: "downloaded_at", accessor: v => v.downloaded_at ? formatters.date(v.downloaded_at) : null },
            { Header: _('actions_col_memory', 'Dash'), id: "val_memory", accessor: v => `${v.val_memory.usage} %`, className: 'number'},
        ];

        const actionsTableProps = {
            ...defaultProps.table({
                showPagination: true,
            }),
            getTrProps: (state, row, column) => {
                if (!row) return {};
                return {
                    className: classNames("clickable"),
                    onClick: (e) => {
                        if (onBattery) onBattery({id: row.original.battery.id})
                    },
                };
            }
        }
        
		return (
            <Box title={_('actions_title', 'Dash')} collapsed={false}>
                <div className={style}>
                    <article>
                        <section className="stats">
                            <article>
                                <span className="iconBadge">
                                    <i className="fa fa-warning" />
                                    <strong>{data.alarms.length}</strong>
                                </span>
                                <h4>{_('actions_title_critical', 'Dash')}</h4>
                            </article>
                        </section>
                        <section className="table">
                            <ReactTable
                                {...actionsTableProps}
                                data={data.alarms}
                                columns={columnsActions}
                            />
                        </section>
                    </article>
                    <article>
                        <section className="stats">
                            <article>
                                <span className="iconBadge">
                                    <i className="fa fa-medkit" />
                                    <strong>{maintenances.length}</strong>
                                </span>
                                <h4>{_('actions_title_maintenances', 'Dash')}</h4>
                            </article>
                        </section>
                        <section className="table">
                            <ReactTable
                                {...actionsTableProps}
                                data={maintenances}
                                columns={columnsMaintenances}
                            />
                        </section>
                    </article>
                    <article>
                        <section className="stats">
                            <article>
                                <span className="iconBadge">
                                    <i className="fa fa-wifi" />
                                    <strong>{data.errors.length}</strong>
                                </span>
                                <h4>{_('actions_title_comm_errors', 'Dash')}</h4>
                            </article>
                        </section>
                        <section className="table">
                            <ReactTable
                                {...actionsTableProps}
                                data={data.errors}
                                columns={columnsErrors}
                            />
                        </section>
                    </article>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Dash/Actions.tsx